// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/ryugu/v1/ryugu.proto (package mono.ryugu.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { AcceptLaborCategoryCandidateRequest, AcceptLaborCategoryCandidateResponse, AcknowledgeAllNotificationsRequest, AcknowledgeAllNotificationsResponse, AcknowledgeNotificationRequest, AcknowledgeNotificationResponse, AcknowledgeRateSelectionReviewRequest, AcknowledgeRateSelectionReviewResponse, AddIssueCommentRequest, AddIssueCommentResponse, AnswerCloseoutChecklistItemRequest, AnswerCloseoutChecklistItemResponse, ApplyPricingSheetReviewRequest, ApplyPricingSheetReviewResponse, ApproveLaborCategoryMappingRequest, ApproveLaborCategoryMappingResponse, AttachTouchpointFileRequest, AttachTouchpointFileResponse, CloseAuditRequest, CloseAuditResponse, ClosePeriodRequest, ClosePeriodResponse, CloseProgramRequest, CloseProgramResponse, CompleteAuditRequest, CompleteAuditResponse, CompleteCloseoutChecklistRequest, CompleteCloseoutChecklistResponse, ConvertRiskToIssueRequest, ConvertRiskToIssueResponse, CorrectLaborCategoryMappingRequest, CorrectLaborCategoryMappingResponse, CorrectPricingSheetBlockRequest, CorrectPricingSheetBlockResponse, CorrectRateObservationRequest, CorrectRateObservationResponse, CreateAuditFromTemplateRequest, CreateAuditFromTemplateResponse, CreateAuditRequest, CreateAuditResponse, CreateCompanyRelationshipRequest, CreateCompanyRelationshipResponse, CreateContactEmploymentRequest, CreateContactEmploymentResponse, CreateCustomerTouchpointRequest, CreateCustomerTouchpointResponse, CreateDSOEntryRequest, CreateDSOEntryResponse, CreateEACEntryRequest, CreateEACEntryResponse, CreateOptionalTaskExerciseRequest, CreateOptionalTaskExerciseResponse, CreateProgramDocumentRequest, CreateProgramDocumentResponse, CreateProgramRequest, CreateProgramResponse, CreateRateObservationRequest, CreateRateObservationResponse, CreateTaskAttachmentRequest, CreateTaskAttachmentResponse, DeleteBusinessUnitRequest, DeleteBusinessUnitResponse, DeleteCapabilityRequest, DeleteCapabilityResponse, DeleteCloseoutOutstandingItemRequest, DeleteCloseoutOutstandingItemResponse, DeleteCloseoutTemplateItemRequest, DeleteCloseoutTemplateItemResponse, DeleteCompanyAliasRequest, DeleteCompanyAliasResponse, DeleteCompanyProfileRequest, DeleteCompanyProfileResponse, DeleteCompanyRelationshipRequest, DeleteCompanyRelationshipResponse, DeleteContactRequest, DeleteContactResponse, DeleteContractVehicleRequest, DeleteContractVehicleResponse, DeleteCPARSScoreRequest, DeleteCPARSScoreResponse, DeleteDeliverableEvidenceRequest, DeleteDeliverableEvidenceResponse, DeleteDeviationRequest, DeleteDeviationResponse, DeleteDSOEntryRequest, DeleteDSOEntryResponse, DeleteEACEntryRequest, DeleteEACEntryResponse, DeleteGovernmentOrganizationRequest, DeleteGovernmentOrganizationResponse, DeleteGrowthOpportunityRequest, DeleteGrowthOpportunityResponse, DeleteIssueRequest, DeleteIssueResponse, DeleteLaborCategoryEntryRequest, DeleteLaborCategoryEntryResponse, DeleteOptionalTaskExerciseRequest, DeleteOptionalTaskExerciseResponse, DeleteOptionalTaskRequest, DeleteOptionalTaskResponse, DeletePeriodOfPerformanceRequest, DeletePeriodOfPerformanceResponse, DeletePortfolioRequest, DeletePortfolioResponse, DeleteProgramCapabilityRequest, DeleteProgramCapabilityResponse, DeleteProgramCompanyAssignmentRequest, DeleteProgramCompanyAssignmentResponse, DeleteProgramCompanyStaffingLineRequest, DeleteProgramCompanyStaffingLineResponse, DeleteProgramContactRequest, DeleteProgramContactResponse, DeleteProgramDocumentRequest, DeleteProgramDocumentResponse, DeleteProgramRequest, DeleteProgramResponse, DeleteProgramRoleAssignmentRequest, DeleteProgramRoleAssignmentResponse, DeleteProgramRoleRequest, DeleteProgramRoleResponse, DeleteProgramTaskRequest, DeleteProgramTaskResponse, DeleteQASPScoreRequest, DeleteQASPScoreResponse, DeleteRateObservationRequest, DeleteRateObservationResponse, DeleteRiskRequest, DeleteRiskResponse, DeleteRoleTypeRequest, DeleteRoleTypeResponse, DeleteSectorRequest, DeleteSectorResponse, DeleteSubcontractorReviewRequest, DeleteSubcontractorReviewResponse, DeleteTaskAttachmentRequest, DeleteTaskAttachmentResponse, DetachTouchpointFileRequest, DetachTouchpointFileResponse, EndContactEmploymentRequest, EndContactEmploymentResponse, EscalateRiskToLeadershipRequest, EscalateRiskToLeadershipResponse, ExportCloseoutChecklistRequest, ExportCloseoutChecklistResponse, FindGlossarySectionRequest, FindGlossarySectionResponse, GenerateTaskInstancesRequest, GenerateTaskInstancesResponse, GetAuditRequest, GetAuditResponse, GetCloseoutChecklistRequest, GetCloseoutChecklistResponse, GetCompanyNotificationDefaultsRequest, GetCompanyNotificationDefaultsResponse, GetDeliverableLookaheadRequest, GetDeliverableLookaheadResponse, GetDeliveryCalendarRequest, GetDeliveryCalendarResponse, GetDeliveryKPIRollupsRequest, GetDeliveryKPIRollupsResponse, GetLaborCategoryEntryHistoryRequest, GetLaborCategoryEntryHistoryResponse, GetLinkedNodesRequest, GetLinkedNodesResponse, GetMyNotificationPreferencesRequest, GetMyNotificationPreferencesResponse, GetOnTimeReportRequest, GetOnTimeReportResponse, GetOpenCorrectiveActionCountsRequest, GetOpenCorrectiveActionCountsResponse, GetOwnCompanyProfileRequest, GetOwnCompanyProfileResponse, GetPeriodCloseoutChecklistRequest, GetPeriodCloseoutChecklistResponse, GetPortfolioDashboardRequest, GetPortfolioDashboardResponse, GetPricingSheetReviewRequest, GetPricingSheetReviewResponse, GetProgramFinancialSummaryRequest, GetProgramFinancialSummaryResponse, GetProgramRequest, GetProgramResponse, GetWeeklyRecapRequest, GetWeeklyRecapResponse, LinkContactUserRequest, LinkContactUserResponse, ListAuditQuestionsRequest, ListAuditQuestionsResponse, ListAuditSectionOwnersRequest, ListAuditSectionOwnersResponse, ListAuditsRequest, ListAuditsResponse, ListAuditTemplatesRequest, ListAuditTemplatesResponse, ListBusinessUnitsRequest, ListBusinessUnitsResponse, ListCapabilitiesRequest, ListCapabilitiesResponse, ListCloseoutTemplatesRequest, ListCloseoutTemplatesResponse, ListCompanyAliasesRequest, ListCompanyAliasesResponse, ListCompanyProfilesRequest, ListCompanyProfilesResponse, ListCompanyRelationshipsRequest, ListCompanyRelationshipsResponse, ListCompanyVehicleHoldingsRequest, ListCompanyVehicleHoldingsResponse, ListContactEmploymentsRequest, ListContactEmploymentsResponse, ListContactMergeEventsRequest, ListContactMergeEventsResponse, ListContactsRequest, ListContactsResponse, ListContactTouchpointsRequest, ListContactTouchpointsResponse, ListContractCLINsRequest, ListContractCLINsResponse, ListContractVehiclesRequest, ListContractVehiclesResponse, ListCorrectiveActionsRequest, ListCorrectiveActionsResponse, ListCPARSScoresRequest, ListCPARSScoresResponse, ListCustomerTouchpointsRequest, ListCustomerTouchpointsResponse, ListDeliverableEvidenceRequest, ListDeliverableEvidenceResponse, ListDeliverableInstancesRequest, ListDeliverableInstancesResponse, ListDeviationsRequest, ListDeviationsResponse, ListDSOEntriesRequest, ListDSOEntriesResponse, ListEACEntriesRequest, ListEACEntriesResponse, ListGovernmentOrganizationsRequest, ListGovernmentOrganizationsResponse, ListGrowthOpportunitiesRequest, ListGrowthOpportunitiesResponse, ListIssueCommentsRequest, ListIssueCommentsResponse, ListIssuesRequest, ListIssuesResponse, ListLaborCategoryAnchorsRequest, ListLaborCategoryAnchorsResponse, ListLaborCategoryCandidatesRequest, ListLaborCategoryCandidatesResponse, ListLaborCategoryEntriesRequest, ListLaborCategoryEntriesResponse, ListLaborCategoryMappingsRequest, ListLaborCategoryMappingsResponse, ListMyAssignedActionsRequest, ListMyAssignedActionsResponse, ListMyNotificationsRequest, ListMyNotificationsResponse, ListNotificationDeliveryStatusRequest, ListNotificationDeliveryStatusResponse, ListOptionalTaskExercisesRequest, ListOptionalTaskExercisesResponse, ListOptionalTasksRequest, ListOptionalTasksResponse, ListOwnCompanyDesignationsRequest, ListOwnCompanyDesignationsResponse, ListPeriodCloseoutsRequest, ListPeriodCloseoutsResponse, ListPeriodsOfPerformanceRequest, ListPeriodsOfPerformanceResponse, ListPlacesOfPerformanceRequest, ListPlacesOfPerformanceResponse, ListPortfoliosRequest, ListPortfoliosResponse, ListPricingSheetReviewsRequest, ListPricingSheetReviewsResponse, ListProgramCapabilitiesRequest, ListProgramCapabilitiesResponse, ListProgramCompaniesRequest, ListProgramCompaniesResponse, ListProgramCompanyStaffingLinesRequest, ListProgramCompanyStaffingLinesResponse, ListProgramContactsRequest, ListProgramContactsResponse, ListProgramDocumentsRequest, ListProgramDocumentsResponse, ListProgramFinancialMonthsRequest, ListProgramFinancialMonthsResponse, ListProgramGrantsRequest, ListProgramGrantsResponse, ListProgramModificationsRequest, ListProgramModificationsResponse, ListProgramOrderCeilingsRequest, ListProgramOrderCeilingsResponse, ListProgramRoleAssignmentsRequest, ListProgramRoleAssignmentsResponse, ListProgramRolesRequest, ListProgramRolesResponse, ListProgramsRequest, ListProgramsResponse, ListProgramTasksRequest, ListProgramTasksResponse, ListQASPScoresRequest, ListQASPScoresResponse, ListRateObservationsRequest, ListRateObservationsResponse, ListRateSelectionsRequest, ListRateSelectionsResponse, ListRegionOwnersRequest, ListRegionOwnersResponse, ListRisksRequest, ListRisksResponse, ListSectorsRequest, ListSectorsResponse, ListSubcontractorReviewsRequest, ListSubcontractorReviewsResponse, ListTaskAttachmentsRequest, ListTaskAttachmentsResponse, ListTaskOrdersRequest, ListTaskOrdersResponse, ListTenantEnumValuesRequest, ListTenantEnumValuesResponse, ListTouchpointFilesRequest, ListTouchpointFilesResponse, MergeContactsRequest, MergeContactsResponse, PingRequest, PingResponse, ProposeLaborCategoryMappingRequest, ProposeLaborCategoryMappingResponse, PurgeProgramRequest, PurgeProgramResponse, ReactivateCapabilityRequest, ReactivateCapabilityResponse, ReactivateContactRequest, ReactivateContactResponse, RejectLaborCategoryCandidateRequest, RejectLaborCategoryCandidateResponse, RejectLaborCategoryMappingRequest, RejectLaborCategoryMappingResponse, RequestCAExtensionRequest, RequestCAExtensionResponse, ResolveContractProgramRequest, ResolveContractProgramResponse, ResolveCorrectiveActionRequest, ResolveCorrectiveActionResponse, ResolvePricingSheetBlockRequest, ResolvePricingSheetBlockResponse, RetireCapabilityRequest, RetireCapabilityResponse, RetireContactRequest, RetireContactResponse, RetireLaborCategoryEntryRequest, RetireLaborCategoryEntryResponse, ReviewAuditRequest, ReviewAuditResponse, SelectRateObservationRequest, SelectRateObservationResponse, SetOwnCompanyProfileRequest, SetOwnCompanyProfileResponse, SetProgramDocumentProcessingRequest, SetProgramDocumentProcessingResponse, SetProgramDocumentTagsRequest, SetProgramDocumentTagsResponse, SetProgramFundingAlertThresholdRequest, SetProgramFundingAlertThresholdResponse, SetRegionOwnerRequest, SetRegionOwnerResponse, StartAuditRequest, StartAuditResponse, StartCloseoutChecklistRequest, StartCloseoutChecklistResponse, StartPeriodCloseoutChecklistRequest, StartPeriodCloseoutChecklistResponse, SubmitAuditForReviewRequest, SubmitAuditForReviewResponse, SubmitDeliverableOccurrenceRequest, SubmitDeliverableOccurrenceResponse, SyncFromExtractionRequest, SyncFromExtractionResponse, SyncGlossarySectionRequest, SyncGlossarySectionResponse, UnlinkContactUserRequest, UnlinkContactUserResponse, UnmergeContactsRequest, UnmergeContactsResponse, UpdateAuditRequest, UpdateAuditResponse, UpdateCompanyNotificationDefaultsRequest, UpdateCompanyNotificationDefaultsResponse, UpdateEACEntryRequest, UpdateEACEntryResponse, UpdateMyNotificationPreferencesRequest, UpdateMyNotificationPreferencesResponse, UpdateOptionalTaskExerciseLineRequest, UpdateOptionalTaskExerciseLineResponse, UpdateOptionalTaskExerciseRequest, UpdateOptionalTaskExerciseResponse, UpdateProgramRequest, UpdateProgramResponse, UpsertAuditQuestionRequest, UpsertAuditQuestionResponse, UpsertAuditSectionOwnerRequest, UpsertAuditSectionOwnerResponse, UpsertAuditTemplateRequest, UpsertAuditTemplateResponse, UpsertBusinessUnitRequest, UpsertBusinessUnitResponse, UpsertCapabilityRequest, UpsertCapabilityResponse, UpsertCloseoutOutstandingItemRequest, UpsertCloseoutOutstandingItemResponse, UpsertCloseoutTemplateItemRequest, UpsertCloseoutTemplateItemResponse, UpsertCompanyAliasRequest, UpsertCompanyAliasResponse, UpsertCompanyProfileRequest, UpsertCompanyProfileResponse, UpsertContactRequest, UpsertContactResponse, UpsertContractVehicleRequest, UpsertContractVehicleResponse, UpsertCorrectiveActionRequest, UpsertCorrectiveActionResponse, UpsertCPARSScoreRequest, UpsertCPARSScoreResponse, UpsertCustomerTouchpointRequest, UpsertCustomerTouchpointResponse, UpsertDeviationRequest, UpsertDeviationResponse, UpsertGovernmentOrganizationRequest, UpsertGovernmentOrganizationResponse, UpsertGrowthOpportunityRequest, UpsertGrowthOpportunityResponse, UpsertIssueRequest, UpsertIssueResponse, UpsertLaborCategoryEntryRequest, UpsertLaborCategoryEntryResponse, UpsertOptionalTaskRequest, UpsertOptionalTaskResponse, UpsertPeriodOfPerformanceRequest, UpsertPeriodOfPerformanceResponse, UpsertPortfolioRequest, UpsertPortfolioResponse, UpsertProgramCapabilityRequest, UpsertProgramCapabilityResponse, UpsertProgramCompanyAssignmentRequest, UpsertProgramCompanyAssignmentResponse, UpsertProgramCompanyStaffingLineRequest, UpsertProgramCompanyStaffingLineResponse, UpsertProgramContactRequest, UpsertProgramContactResponse, UpsertProgramFinancialMonthRequest, UpsertProgramFinancialMonthResponse, UpsertProgramRoleAssignmentRequest, UpsertProgramRoleAssignmentResponse, UpsertProgramRoleRequest, UpsertProgramRoleResponse, UpsertProgramTaskRequest, UpsertProgramTaskResponse, UpsertQASPScoreRequest, UpsertQASPScoreResponse, UpsertRiskRequest, UpsertRiskResponse, UpsertSectorRequest, UpsertSectorResponse, UpsertSubcontractorReviewRequest, UpsertSubcontractorReviewResponse, UpsertTenantEnumValueRequest, UpsertTenantEnumValueResponse, VerifyCorrectiveActionRequest, VerifyCorrectiveActionResponse, WithdrawCorrectiveActionRequest, WithdrawCorrectiveActionResponse, WithdrawLaborCategoryMappingRequest, WithdrawLaborCategoryMappingResponse } from "./ryugu_pb";
import { MethodKind } from "@bufbuild/protobuf";
import { ApplyExecutionScopeChangeSetRequest, ApplyExecutionScopeChangeSetResponse, ApproveExecutionScopeChangeSetRequest, ApproveExecutionScopeChangeSetResponse, BulkStageScopeDeviationRequest, BulkStageScopeDeviationResponse, CreateManualExecutionScopeRequest, CreateManualExecutionScopeResponse, GetExecutionScopeCoverageRequest, GetExecutionScopeCoverageResponse, GetExecutionScopeImportReviewRequest, GetExecutionScopeImportReviewResponse, GetExecutionScopeRequest, GetExecutionScopeResponse, GetExecutionScopeTimelineRequest, GetExecutionScopeTimelineResponse, ListExecutionScopesRequest, ListExecutionScopesResponse, ListScopePressureItemsRequest, ListScopePressureItemsResponse, ListUnallocatedAuthorityRequest, ListUnallocatedAuthorityResponse, PreviewExecutionScopeApplyRequest, PreviewExecutionScopeApplyResponse, ResolveExecutionScopeProposalRequest, ResolveExecutionScopeProposalResponse, StageExecutionScopeArtifactRequest, StageExecutionScopeArtifactResponse, StageExecutionScopeCorrectionRequest, StageExecutionScopeCorrectionResponse, UpdateManualExecutionScopeDraftRequest, UpdateManualExecutionScopeDraftResponse } from "./execution_scope_pb";
/**
 * DeliveryService is the System of Record (SoR) for contract/program delivery management.
 * It is the canonical source of truth for contract/program identity and operational tracking.
 *
 * @generated from service mono.ryugu.v1.DeliveryService
 */ export const DeliveryService = {
    typeName: "mono.ryugu.v1.DeliveryService",
    methods: {
        /**
     * Health
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.Ping
     */ ping: {
            name: "Ping",
            I: PingRequest,
            O: PingResponse,
            kind: MethodKind.Unary
        },
        /**
     * === Org Hierarchy ===
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListSectors
     */ listSectors: {
            name: "ListSectors",
            I: ListSectorsRequest,
            O: ListSectorsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpsertSector
     */ upsertSector: {
            name: "UpsertSector",
            I: UpsertSectorRequest,
            O: UpsertSectorResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeleteSector
     */ deleteSector: {
            name: "DeleteSector",
            I: DeleteSectorRequest,
            O: DeleteSectorResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListBusinessUnits
     */ listBusinessUnits: {
            name: "ListBusinessUnits",
            I: ListBusinessUnitsRequest,
            O: ListBusinessUnitsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpsertBusinessUnit
     */ upsertBusinessUnit: {
            name: "UpsertBusinessUnit",
            I: UpsertBusinessUnitRequest,
            O: UpsertBusinessUnitResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeleteBusinessUnit
     */ deleteBusinessUnit: {
            name: "DeleteBusinessUnit",
            I: DeleteBusinessUnitRequest,
            O: DeleteBusinessUnitResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListPortfolios
     */ listPortfolios: {
            name: "ListPortfolios",
            I: ListPortfoliosRequest,
            O: ListPortfoliosResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpsertPortfolio
     */ upsertPortfolio: {
            name: "UpsertPortfolio",
            I: UpsertPortfolioRequest,
            O: UpsertPortfolioResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeletePortfolio
     */ deletePortfolio: {
            name: "DeletePortfolio",
            I: DeletePortfolioRequest,
            O: DeletePortfolioResponse,
            kind: MethodKind.Unary
        },
        /**
     * === Program CRUD ===
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.CreateProgram
     */ createProgram: {
            name: "CreateProgram",
            I: CreateProgramRequest,
            O: CreateProgramResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.GetProgram
     */ getProgram: {
            name: "GetProgram",
            I: GetProgramRequest,
            O: GetProgramResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpdateProgram
     */ updateProgram: {
            name: "UpdateProgram",
            I: UpdateProgramRequest,
            O: UpdateProgramResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListPrograms
     */ listPrograms: {
            name: "ListPrograms",
            I: ListProgramsRequest,
            O: ListProgramsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Resolve a program by contract identity before minting a duplicate project.
     * Returns whether the caller can view it or must request access.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ResolveContractProgram
     */ resolveContractProgram: {
            name: "ResolveContractProgram",
            I: ResolveContractProgramRequest,
            O: ResolveContractProgramResponse,
            kind: MethodKind.Unary
        },
        /**
     * DeleteProgram archives (soft-deletes) — recoverable.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeleteProgram
     */ deleteProgram: {
            name: "DeleteProgram",
            I: DeleteProgramRequest,
            O: DeleteProgramResponse,
            kind: MethodKind.Unary
        },
        /**
     * PurgeProgram permanently destroys a program and all of its delivery data.
     * Tenant admins only (delivery_program_purge_policy). A real purge requires
     * confirm_name to equal the program's full name; dry_run reports what would
     * be destroyed without touching anything.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.PurgeProgram
     */ purgeProgram: {
            name: "PurgeProgram",
            I: PurgeProgramRequest,
            O: PurgeProgramResponse,
            kind: MethodKind.Unary
        },
        /**
     * === Program Roles (legacy freetext) ===
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListProgramRoles
     */ listProgramRoles: {
            name: "ListProgramRoles",
            I: ListProgramRolesRequest,
            O: ListProgramRolesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpsertProgramRole
     */ upsertProgramRole: {
            name: "UpsertProgramRole",
            I: UpsertProgramRoleRequest,
            O: UpsertProgramRoleResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeleteProgramRole
     */ deleteProgramRole: {
            name: "DeleteProgramRole",
            I: DeleteProgramRoleRequest,
            O: DeleteProgramRoleResponse,
            kind: MethodKind.Unary
        },
        /**
     * === Foundation: tenant enums, government orgs, role assignments ===
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListTenantEnumValues
     */ listTenantEnumValues: {
            name: "ListTenantEnumValues",
            I: ListTenantEnumValuesRequest,
            O: ListTenantEnumValuesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpsertTenantEnumValue
     */ upsertTenantEnumValue: {
            name: "UpsertTenantEnumValue",
            I: UpsertTenantEnumValueRequest,
            O: UpsertTenantEnumValueResponse,
            kind: MethodKind.Unary
        },
        /**
     * DeleteRoleType removes a tenant-owned role name (edits go through
     * UpsertTenantEnumValue — #931's general-purpose upsert with
     * copy-on-write for _system rows; our narrower UpsertRoleType retired
     * in its favor at reconciliation).
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeleteRoleType
     */ deleteRoleType: {
            name: "DeleteRoleType",
            I: DeleteRoleTypeRequest,
            O: DeleteRoleTypeResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListGovernmentOrganizations
     */ listGovernmentOrganizations: {
            name: "ListGovernmentOrganizations",
            I: ListGovernmentOrganizationsRequest,
            O: ListGovernmentOrganizationsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpsertGovernmentOrganization
     */ upsertGovernmentOrganization: {
            name: "UpsertGovernmentOrganization",
            I: UpsertGovernmentOrganizationRequest,
            O: UpsertGovernmentOrganizationResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeleteGovernmentOrganization
     */ deleteGovernmentOrganization: {
            name: "DeleteGovernmentOrganization",
            I: DeleteGovernmentOrganizationRequest,
            O: DeleteGovernmentOrganizationResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListProgramRoleAssignments
     */ listProgramRoleAssignments: {
            name: "ListProgramRoleAssignments",
            I: ListProgramRoleAssignmentsRequest,
            O: ListProgramRoleAssignmentsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpsertProgramRoleAssignment
     */ upsertProgramRoleAssignment: {
            name: "UpsertProgramRoleAssignment",
            I: UpsertProgramRoleAssignmentRequest,
            O: UpsertProgramRoleAssignmentResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeleteProgramRoleAssignment
     */ deleteProgramRoleAssignment: {
            name: "DeleteProgramRoleAssignment",
            I: DeleteProgramRoleAssignmentRequest,
            O: DeleteProgramRoleAssignmentResponse,
            kind: MethodKind.Unary
        },
        /**
     * ListProgramGrants returns the live authz grants that reach this program —
     * its own scope node plus its ancestor chain (mirrors the resolver's own
     * walk); tenant-root grants are summarized as a count, not itemized (SAD-99
     * requirements 2/3). Authorized on `manage_members` for this program (the
     * program lead / delivery VP authority — member_authority.go), not on
     * baseline admin/internal: enies-lobby's admin surface
     * (AdminListAssignmentsForScopeNode) stays admin-only and unwidened; this is
     * a narrower, program-scoped read ryugu computes itself from pangaea's
     * GetRoleAssignmentsForScope, so a Program Lead can finally see everyone
     * who holds real access here — including people granted directly through
     * /admin/access with no roster seat at all.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListProgramGrants
     */ listProgramGrants: {
            name: "ListProgramGrants",
            I: ListProgramGrantsRequest,
            O: ListProgramGrantsResponse,
            kind: MethodKind.Unary
        },
        /**
     * === Company Registry (company-wide, deduplicated) ===
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListCompanyProfiles
     */ listCompanyProfiles: {
            name: "ListCompanyProfiles",
            I: ListCompanyProfilesRequest,
            O: ListCompanyProfilesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpsertCompanyProfile
     */ upsertCompanyProfile: {
            name: "UpsertCompanyProfile",
            I: UpsertCompanyProfileRequest,
            O: UpsertCompanyProfileResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeleteCompanyProfile
     */ deleteCompanyProfile: {
            name: "DeleteCompanyProfile",
            I: DeleteCompanyProfileRequest,
            O: DeleteCompanyProfileResponse,
            kind: MethodKind.Unary
        },
        /**
     * Resolves the caller's own registry profile ("the current org") for
     * autofill flows like Role=Prime. Empty profile when unresolvable.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.GetOwnCompanyProfile
     */ getOwnCompanyProfile: {
            name: "GetOwnCompanyProfile",
            I: GetOwnCompanyProfileRequest,
            O: GetOwnCompanyProfileResponse,
            kind: MethodKind.Unary
        },
        /**
     * SetOwnCompanyProfile corrects which CompanyProfile IS us (SAD-548): an
     * explicit, auditable, correctable decision that moves a pointer, not a
     * rewrite — it never touches the relationships, rates or attributions
     * already recorded against either the old or the new holder. Company
     * settings authority (admin, or area:company_settings on the tenant root).
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.SetOwnCompanyProfile
     */ setOwnCompanyProfile: {
            name: "SetOwnCompanyProfile",
            I: SetOwnCompanyProfileRequest,
            O: SetOwnCompanyProfileResponse,
            kind: MethodKind.Unary
        },
        /**
     * ListOwnCompanyDesignations returns the append-only audit trail
     * SetOwnCompanyProfile writes one row to on every call.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListOwnCompanyDesignations
     */ listOwnCompanyDesignations: {
            name: "ListOwnCompanyDesignations",
            I: ListOwnCompanyDesignationsRequest,
            O: ListOwnCompanyDesignationsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Company lineage: aliases resolve a former name to its surviving profile at
     * match time; dated edges record the merger/rename/acquisition that connects
     * two profiles. Writes take registries authority; nothing merges
     * automatically — a human records the fact, both eras keep their own rates.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpsertCompanyAlias
     */ upsertCompanyAlias: {
            name: "UpsertCompanyAlias",
            I: UpsertCompanyAliasRequest,
            O: UpsertCompanyAliasResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListCompanyAliases
     */ listCompanyAliases: {
            name: "ListCompanyAliases",
            I: ListCompanyAliasesRequest,
            O: ListCompanyAliasesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeleteCompanyAlias
     */ deleteCompanyAlias: {
            name: "DeleteCompanyAlias",
            I: DeleteCompanyAliasRequest,
            O: DeleteCompanyAliasResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.CreateCompanyRelationship
     */ createCompanyRelationship: {
            name: "CreateCompanyRelationship",
            I: CreateCompanyRelationshipRequest,
            O: CreateCompanyRelationshipResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListCompanyRelationships
     */ listCompanyRelationships: {
            name: "ListCompanyRelationships",
            I: ListCompanyRelationshipsRequest,
            O: ListCompanyRelationshipsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeleteCompanyRelationship
     */ deleteCompanyRelationship: {
            name: "DeleteCompanyRelationship",
            I: DeleteCompanyRelationshipRequest,
            O: DeleteCompanyRelationshipResponse,
            kind: MethodKind.Unary
        },
        /**
     * Company-vehicle holdings (SAD-432): which contract vehicles a company
     * holds a seat on. Read-only — maintenance is C1.4/SAD-435's job.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListCompanyVehicleHoldings
     */ listCompanyVehicleHoldings: {
            name: "ListCompanyVehicleHoldings",
            I: ListCompanyVehicleHoldingsRequest,
            O: ListCompanyVehicleHoldingsResponse,
            kind: MethodKind.Unary
        },
        /**
     * === Program Company Assignments (junction) ===
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListProgramCompanies
     */ listProgramCompanies: {
            name: "ListProgramCompanies",
            I: ListProgramCompaniesRequest,
            O: ListProgramCompaniesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpsertProgramCompanyAssignment
     */ upsertProgramCompanyAssignment: {
            name: "UpsertProgramCompanyAssignment",
            I: UpsertProgramCompanyAssignmentRequest,
            O: UpsertProgramCompanyAssignmentResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeleteProgramCompanyAssignment
     */ deleteProgramCompanyAssignment: {
            name: "DeleteProgramCompanyAssignment",
            I: DeleteProgramCompanyAssignmentRequest,
            O: DeleteProgramCompanyAssignmentResponse,
            kind: MethodKind.Unary
        },
        /**
     * === Program Company Staffing Lines (child ledger of a company assignment) ===
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListProgramCompanyStaffingLines
     */ listProgramCompanyStaffingLines: {
            name: "ListProgramCompanyStaffingLines",
            I: ListProgramCompanyStaffingLinesRequest,
            O: ListProgramCompanyStaffingLinesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpsertProgramCompanyStaffingLine
     */ upsertProgramCompanyStaffingLine: {
            name: "UpsertProgramCompanyStaffingLine",
            I: UpsertProgramCompanyStaffingLineRequest,
            O: UpsertProgramCompanyStaffingLineResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeleteProgramCompanyStaffingLine
     */ deleteProgramCompanyStaffingLine: {
            name: "DeleteProgramCompanyStaffingLine",
            I: DeleteProgramCompanyStaffingLineRequest,
            O: DeleteProgramCompanyStaffingLineResponse,
            kind: MethodKind.Unary
        },
        /**
     * === Contact Registry (company-wide, deduplicated) ===
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListContacts
     */ listContacts: {
            name: "ListContacts",
            I: ListContactsRequest,
            O: ListContactsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpsertContact
     */ upsertContact: {
            name: "UpsertContact",
            I: UpsertContactRequest,
            O: UpsertContactResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeleteContact
     */ deleteContact: {
            name: "DeleteContact",
            I: DeleteContactRequest,
            O: DeleteContactResponse,
            kind: MethodKind.Unary
        },
        /**
     * Non-destructive lifecycle (SAD-433): hides a contact from new selections
     * without touching employments, touchpoints or staffing.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.RetireContact
     */ retireContact: {
            name: "RetireContact",
            I: RetireContactRequest,
            O: RetireContactResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.ReactivateContact
     */ reactivateContact: {
            name: "ReactivateContact",
            I: ReactivateContactRequest,
            O: ReactivateContactResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListContactTouchpoints
     */ listContactTouchpoints: {
            name: "ListContactTouchpoints",
            I: ListContactTouchpointsRequest,
            O: ListContactTouchpointsResponse,
            kind: MethodKind.Unary
        },
        /**
     * People Graph (Phase 3 slice 2): employment history + person merges.
     * Writes are shared-catalog curation (area:registries on the org root).
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListContactEmployments
     */ listContactEmployments: {
            name: "ListContactEmployments",
            I: ListContactEmploymentsRequest,
            O: ListContactEmploymentsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.CreateContactEmployment
     */ createContactEmployment: {
            name: "CreateContactEmployment",
            I: CreateContactEmploymentRequest,
            O: CreateContactEmploymentResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.EndContactEmployment
     */ endContactEmployment: {
            name: "EndContactEmployment",
            I: EndContactEmploymentRequest,
            O: EndContactEmploymentResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.MergeContacts
     */ mergeContacts: {
            name: "MergeContacts",
            I: MergeContactsRequest,
            O: MergeContactsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UnmergeContacts
     */ unmergeContacts: {
            name: "UnmergeContacts",
            I: UnmergeContactsRequest,
            O: UnmergeContactsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListContactMergeEvents
     */ listContactMergeEvents: {
            name: "ListContactMergeEvents",
            I: ListContactMergeEventsRequest,
            O: ListContactMergeEventsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Rate Book (Phase 4): reads are tenant-scoped; writes are shared-catalog
     * curation gated on area:registries.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListRateObservations
     */ listRateObservations: {
            name: "ListRateObservations",
            I: ListRateObservationsRequest,
            O: ListRateObservationsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.CreateRateObservation
     */ createRateObservation: {
            name: "CreateRateObservation",
            I: CreateRateObservationRequest,
            O: CreateRateObservationResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.CorrectRateObservation
     */ correctRateObservation: {
            name: "CorrectRateObservation",
            I: CorrectRateObservationRequest,
            O: CorrectRateObservationResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeleteRateObservation
     */ deleteRateObservation: {
            name: "DeleteRateObservation",
            I: DeleteRateObservationRequest,
            O: DeleteRateObservationResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.SelectRateObservation
     */ selectRateObservation: {
            name: "SelectRateObservation",
            I: SelectRateObservationRequest,
            O: SelectRateObservationResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListRateSelections
     */ listRateSelections: {
            name: "ListRateSelections",
            I: ListRateSelectionsRequest,
            O: ListRateSelectionsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.AcknowledgeRateSelectionReview
     */ acknowledgeRateSelectionReview: {
            name: "AcknowledgeRateSelectionReview",
            I: AcknowledgeRateSelectionReviewRequest,
            O: AcknowledgeRateSelectionReviewResponse,
            kind: MethodKind.Unary
        },
        /**
     * Pricing sheet review (Phase 4 slice 2b). An uploaded sheet is staged as a
     * change set of type 'PricingSheet'; nothing reaches the rate book until a
     * human accepts a block. Named for what a reviewer is doing rather than for
     * the change-set plumbing underneath, because "review the pricing sheet" is
     * the task and "resolve change items" is the mechanism.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListPricingSheetReviews
     */ listPricingSheetReviews: {
            name: "ListPricingSheetReviews",
            I: ListPricingSheetReviewsRequest,
            O: ListPricingSheetReviewsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.GetPricingSheetReview
     */ getPricingSheetReview: {
            name: "GetPricingSheetReview",
            I: GetPricingSheetReviewRequest,
            O: GetPricingSheetReviewResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.ResolvePricingSheetBlock
     */ resolvePricingSheetBlock: {
            name: "ResolvePricingSheetBlock",
            I: ResolvePricingSheetBlockRequest,
            O: ResolvePricingSheetBlockResponse,
            kind: MethodKind.Unary
        },
        /**
     * SAD-449 / RATE-05 (C4-07..09): correct a staged block's interpretation and
     * resolve its company or labor category BEFORE commit. Rewrites only the
     * item's approved value; the parser's proposal and the registry are untouched.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.CorrectPricingSheetBlock
     */ correctPricingSheetBlock: {
            name: "CorrectPricingSheetBlock",
            I: CorrectPricingSheetBlockRequest,
            O: CorrectPricingSheetBlockResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.ApplyPricingSheetReview
     */ applyPricingSheetReview: {
            name: "ApplyPricingSheetReview",
            I: ApplyPricingSheetReviewRequest,
            O: ApplyPricingSheetReviewResponse,
            kind: MethodKind.Unary
        },
        /**
     * Lifecycle linked chips (P-L1/P-L2): given any lifecycle record, what else
     * is attached to it. One resolver serves every surface — record chips, Growth
     * home, cockpit, meeting pack — so they cannot drift apart
     * (major-push/lcat-intelligence/09-lifecycle-spine.md).
     *
     * Named Get* deliberately: ryugu's read/write partition classifies by verb
     * prefix, and a read must be inside that system rather than an exception to
     * it. Tenant comes from the principal; PROGRAM-kind results additionally pass
     * per-program viewer projection in the handler (a hybrid, like
     * GetOnTimeReport) so a member cannot learn about a program they cannot view.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.GetLinkedNodes
     */ getLinkedNodes: {
            name: "GetLinkedNodes",
            I: GetLinkedNodesRequest,
            O: GetLinkedNodesResponse,
            kind: MethodKind.Unary
        },
        /**
     * Contact ↔ platform-user stable linkage (WS6/K6): the roster grant path
     * resolves the stored link first; email is discovery-then-persist, never
     * the standing join. Link refuses a user already linked to another live
     * contact (one contact per user per tenant).
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.LinkContactUser
     */ linkContactUser: {
            name: "LinkContactUser",
            I: LinkContactUserRequest,
            O: LinkContactUserResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UnlinkContactUser
     */ unlinkContactUser: {
            name: "UnlinkContactUser",
            I: UnlinkContactUserRequest,
            O: UnlinkContactUserResponse,
            kind: MethodKind.Unary
        },
        /**
     * === Capability Registry (company-wide catalog, deduplicated by name) ===
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListCapabilities
     */ listCapabilities: {
            name: "ListCapabilities",
            I: ListCapabilitiesRequest,
            O: ListCapabilitiesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpsertCapability
     */ upsertCapability: {
            name: "UpsertCapability",
            I: UpsertCapabilityRequest,
            O: UpsertCapabilityResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeleteCapability
     */ deleteCapability: {
            name: "DeleteCapability",
            I: DeleteCapabilityRequest,
            O: DeleteCapabilityResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.RetireCapability
     */ retireCapability: {
            name: "RetireCapability",
            I: RetireCapabilityRequest,
            O: RetireCapabilityResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.ReactivateCapability
     */ reactivateCapability: {
            name: "ReactivateCapability",
            I: ReactivateCapabilityRequest,
            O: ReactivateCapabilityResponse,
            kind: MethodKind.Unary
        },
        /**
     * === Program Contact Assignments (junction) ===
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListProgramContacts
     */ listProgramContacts: {
            name: "ListProgramContacts",
            I: ListProgramContactsRequest,
            O: ListProgramContactsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpsertProgramContact
     */ upsertProgramContact: {
            name: "UpsertProgramContact",
            I: UpsertProgramContactRequest,
            O: UpsertProgramContactResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeleteProgramContact
     */ deleteProgramContact: {
            name: "DeleteProgramContact",
            I: DeleteProgramContactRequest,
            O: DeleteProgramContactResponse,
            kind: MethodKind.Unary
        },
        /**
     * === Contract Vehicles (company-wide, deduplicated) ===
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListContractVehicles
     */ listContractVehicles: {
            name: "ListContractVehicles",
            I: ListContractVehiclesRequest,
            O: ListContractVehiclesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpsertContractVehicle
     */ upsertContractVehicle: {
            name: "UpsertContractVehicle",
            I: UpsertContractVehicleRequest,
            O: UpsertContractVehicleResponse,
            kind: MethodKind.Unary
        },
        /**
     * -------- Labor category registry (Phase 2a, major-push/lcat-intelligence) --------
     * Tenant LCAT catalog: lists/pickers return CURRENT versions only; the
     * detail drawer reads the version chain via history. Writes are gated on
     * area:registries (requireRegistryAuthority), same as companies/vehicles.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListLaborCategoryEntries
     */ listLaborCategoryEntries: {
            name: "ListLaborCategoryEntries",
            I: ListLaborCategoryEntriesRequest,
            O: ListLaborCategoryEntriesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpsertLaborCategoryEntry
     */ upsertLaborCategoryEntry: {
            name: "UpsertLaborCategoryEntry",
            I: UpsertLaborCategoryEntryRequest,
            O: UpsertLaborCategoryEntryResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeleteLaborCategoryEntry
     */ deleteLaborCategoryEntry: {
            name: "DeleteLaborCategoryEntry",
            I: DeleteLaborCategoryEntryRequest,
            O: DeleteLaborCategoryEntryResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.RetireLaborCategoryEntry
     */ retireLaborCategoryEntry: {
            name: "RetireLaborCategoryEntry",
            I: RetireLaborCategoryEntryRequest,
            O: RetireLaborCategoryEntryResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.GetLaborCategoryEntryHistory
     */ getLaborCategoryEntryHistory: {
            name: "GetLaborCategoryEntryHistory",
            I: GetLaborCategoryEntryHistoryRequest,
            O: GetLaborCategoryEntryHistoryResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListLaborCategoryCandidates
     */ listLaborCategoryCandidates: {
            name: "ListLaborCategoryCandidates",
            I: ListLaborCategoryCandidatesRequest,
            O: ListLaborCategoryCandidatesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.AcceptLaborCategoryCandidate
     */ acceptLaborCategoryCandidate: {
            name: "AcceptLaborCategoryCandidate",
            I: AcceptLaborCategoryCandidateRequest,
            O: AcceptLaborCategoryCandidateResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.RejectLaborCategoryCandidate
     */ rejectLaborCategoryCandidate: {
            name: "RejectLaborCategoryCandidate",
            I: RejectLaborCategoryCandidateRequest,
            O: RejectLaborCategoryCandidateResponse,
            kind: MethodKind.Unary
        },
        /**
     * -------- Rosetta: anchors + mappings (Phase 2b slice 2) --------
     * Anchors are global SOC reference rows (read-only). Mapping writes are
     * shared-catalog curation, gated like entries (area:registries); decisions
     * carry the deciding principal and are terminal.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListLaborCategoryAnchors
     */ listLaborCategoryAnchors: {
            name: "ListLaborCategoryAnchors",
            I: ListLaborCategoryAnchorsRequest,
            O: ListLaborCategoryAnchorsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.ProposeLaborCategoryMapping
     */ proposeLaborCategoryMapping: {
            name: "ProposeLaborCategoryMapping",
            I: ProposeLaborCategoryMappingRequest,
            O: ProposeLaborCategoryMappingResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListLaborCategoryMappings
     */ listLaborCategoryMappings: {
            name: "ListLaborCategoryMappings",
            I: ListLaborCategoryMappingsRequest,
            O: ListLaborCategoryMappingsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.ApproveLaborCategoryMapping
     */ approveLaborCategoryMapping: {
            name: "ApproveLaborCategoryMapping",
            I: ApproveLaborCategoryMappingRequest,
            O: ApproveLaborCategoryMappingResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.RejectLaborCategoryMapping
     */ rejectLaborCategoryMapping: {
            name: "RejectLaborCategoryMapping",
            I: RejectLaborCategoryMappingRequest,
            O: RejectLaborCategoryMappingResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.CorrectLaborCategoryMapping
     */ correctLaborCategoryMapping: {
            name: "CorrectLaborCategoryMapping",
            I: CorrectLaborCategoryMappingRequest,
            O: CorrectLaborCategoryMappingResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.WithdrawLaborCategoryMapping
     */ withdrawLaborCategoryMapping: {
            name: "WithdrawLaborCategoryMapping",
            I: WithdrawLaborCategoryMappingRequest,
            O: WithdrawLaborCategoryMappingResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeleteContractVehicle
     */ deleteContractVehicle: {
            name: "DeleteContractVehicle",
            I: DeleteContractVehicleRequest,
            O: DeleteContractVehicleResponse,
            kind: MethodKind.Unary
        },
        /**
     * === Periods of Performance ===
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListPeriodsOfPerformance
     */ listPeriodsOfPerformance: {
            name: "ListPeriodsOfPerformance",
            I: ListPeriodsOfPerformanceRequest,
            O: ListPeriodsOfPerformanceResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpsertPeriodOfPerformance
     */ upsertPeriodOfPerformance: {
            name: "UpsertPeriodOfPerformance",
            I: UpsertPeriodOfPerformanceRequest,
            O: UpsertPeriodOfPerformanceResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeletePeriodOfPerformance
     */ deletePeriodOfPerformance: {
            name: "DeletePeriodOfPerformance",
            I: DeletePeriodOfPerformanceRequest,
            O: DeletePeriodOfPerformanceResponse,
            kind: MethodKind.Unary
        },
        /**
     * === Optional Tasks ===
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListOptionalTasks
     */ listOptionalTasks: {
            name: "ListOptionalTasks",
            I: ListOptionalTasksRequest,
            O: ListOptionalTasksResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpsertOptionalTask
     */ upsertOptionalTask: {
            name: "UpsertOptionalTask",
            I: UpsertOptionalTaskRequest,
            O: UpsertOptionalTaskResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeleteOptionalTask
     */ deleteOptionalTask: {
            name: "DeleteOptionalTask",
            I: DeleteOptionalTaskRequest,
            O: DeleteOptionalTaskResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.CreateOptionalTaskExercise
     */ createOptionalTaskExercise: {
            name: "CreateOptionalTaskExercise",
            I: CreateOptionalTaskExerciseRequest,
            O: CreateOptionalTaskExerciseResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpdateOptionalTaskExercise
     */ updateOptionalTaskExercise: {
            name: "UpdateOptionalTaskExercise",
            I: UpdateOptionalTaskExerciseRequest,
            O: UpdateOptionalTaskExerciseResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpdateOptionalTaskExerciseLine
     */ updateOptionalTaskExerciseLine: {
            name: "UpdateOptionalTaskExerciseLine",
            I: UpdateOptionalTaskExerciseLineRequest,
            O: UpdateOptionalTaskExerciseLineResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListOptionalTaskExercises
     */ listOptionalTaskExercises: {
            name: "ListOptionalTaskExercises",
            I: ListOptionalTaskExercisesRequest,
            O: ListOptionalTaskExercisesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeleteOptionalTaskExercise
     */ deleteOptionalTaskExercise: {
            name: "DeleteOptionalTaskExercise",
            I: DeleteOptionalTaskExerciseRequest,
            O: DeleteOptionalTaskExerciseResponse,
            kind: MethodKind.Unary
        },
        /**
     * === Capabilities ===
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListProgramCapabilities
     */ listProgramCapabilities: {
            name: "ListProgramCapabilities",
            I: ListProgramCapabilitiesRequest,
            O: ListProgramCapabilitiesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpsertProgramCapability
     */ upsertProgramCapability: {
            name: "UpsertProgramCapability",
            I: UpsertProgramCapabilityRequest,
            O: UpsertProgramCapabilityResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeleteProgramCapability
     */ deleteProgramCapability: {
            name: "DeleteProgramCapability",
            I: DeleteProgramCapabilityRequest,
            O: DeleteProgramCapabilityResponse,
            kind: MethodKind.Unary
        },
        /**
     * === Program Tasks (Deliverable Tracking) ===
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListProgramTasks
     */ listProgramTasks: {
            name: "ListProgramTasks",
            I: ListProgramTasksRequest,
            O: ListProgramTasksResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpsertProgramTask
     */ upsertProgramTask: {
            name: "UpsertProgramTask",
            I: UpsertProgramTaskRequest,
            O: UpsertProgramTaskResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeleteProgramTask
     */ deleteProgramTask: {
            name: "DeleteProgramTask",
            I: DeleteProgramTaskRequest,
            O: DeleteProgramTaskResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.GenerateTaskInstances
     */ generateTaskInstances: {
            name: "GenerateTaskInstances",
            I: GenerateTaskInstancesRequest,
            O: GenerateTaskInstancesResponse,
            kind: MethodKind.Unary
        },
        /**
     * Materialized recurring-deliverable occurrences (one per due date) for a
     * program, grouped by the FE into deliverable rows with an N/M-complete badge
     * and an expandable dated schedule. Also the source for instance-driven KPIs.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListDeliverableInstances
     */ listDeliverableInstances: {
            name: "ListDeliverableInstances",
            I: ListDeliverableInstancesRequest,
            O: ListDeliverableInstancesResponse,
            kind: MethodKind.Unary
        },
        /**
     * Record delivery of one occurrence (with a back-datable delivery date +
     * evidence). Flips the instance to SUBMITTED and returns the updated view.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.SubmitDeliverableOccurrence
     */ submitDeliverableOccurrence: {
            name: "SubmitDeliverableOccurrence",
            I: SubmitDeliverableOccurrenceRequest,
            O: SubmitDeliverableOccurrenceResponse,
            kind: MethodKind.Unary
        },
        /**
     * Evidence read-back + audit-logged soft deletion for one occurrence.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListDeliverableEvidence
     */ listDeliverableEvidence: {
            name: "ListDeliverableEvidence",
            I: ListDeliverableEvidenceRequest,
            O: ListDeliverableEvidenceResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeleteDeliverableEvidence
     */ deleteDeliverableEvidence: {
            name: "DeleteDeliverableEvidence",
            I: DeleteDeliverableEvidenceRequest,
            O: DeleteDeliverableEvidenceResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListTaskAttachments
     */ listTaskAttachments: {
            name: "ListTaskAttachments",
            I: ListTaskAttachmentsRequest,
            O: ListTaskAttachmentsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.CreateTaskAttachment
     */ createTaskAttachment: {
            name: "CreateTaskAttachment",
            I: CreateTaskAttachmentRequest,
            O: CreateTaskAttachmentResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeleteTaskAttachment
     */ deleteTaskAttachment: {
            name: "DeleteTaskAttachment",
            I: DeleteTaskAttachmentRequest,
            O: DeleteTaskAttachmentResponse,
            kind: MethodKind.Unary
        },
        /**
     * === Audits ===
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListAudits
     */ listAudits: {
            name: "ListAudits",
            I: ListAuditsRequest,
            O: ListAuditsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.GetAudit
     */ getAudit: {
            name: "GetAudit",
            I: GetAuditRequest,
            O: GetAuditResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.CreateAudit
     */ createAudit: {
            name: "CreateAudit",
            I: CreateAuditRequest,
            O: CreateAuditResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpdateAudit
     */ updateAudit: {
            name: "UpdateAudit",
            I: UpdateAuditRequest,
            O: UpdateAuditResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.SubmitAuditForReview
     */ submitAuditForReview: {
            name: "SubmitAuditForReview",
            I: SubmitAuditForReviewRequest,
            O: SubmitAuditForReviewResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.ReviewAudit
     */ reviewAudit: {
            name: "ReviewAudit",
            I: ReviewAuditRequest,
            O: ReviewAuditResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.CloseAudit
     */ closeAudit: {
            name: "CloseAudit",
            I: CloseAuditRequest,
            O: CloseAuditResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListAuditQuestions
     */ listAuditQuestions: {
            name: "ListAuditQuestions",
            I: ListAuditQuestionsRequest,
            O: ListAuditQuestionsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpsertAuditQuestion
     */ upsertAuditQuestion: {
            name: "UpsertAuditQuestion",
            I: UpsertAuditQuestionRequest,
            O: UpsertAuditQuestionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListCorrectiveActions
     */ listCorrectiveActions: {
            name: "ListCorrectiveActions",
            I: ListCorrectiveActionsRequest,
            O: ListCorrectiveActionsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpsertCorrectiveAction
     */ upsertCorrectiveAction: {
            name: "UpsertCorrectiveAction",
            I: UpsertCorrectiveActionRequest,
            O: UpsertCorrectiveActionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.RequestCAExtension
     */ requestCAExtension: {
            name: "RequestCAExtension",
            I: RequestCAExtensionRequest,
            O: RequestCAExtensionResponse,
            kind: MethodKind.Unary
        },
        /**
     * === Audits (planned monthly workflow) ===
     * StartAudit creates (or starts a scheduled) monthly full-program audit from
     * the locked standard checklist, in state In Progress.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.StartAudit
     */ startAudit: {
            name: "StartAudit",
            I: StartAuditRequest,
            O: StartAuditResponse,
            kind: MethodKind.Unary
        },
        /**
     * CompleteAudit finalizes the audit (In Progress / Corrective Actions Open →
     * Complete) once every item is reviewed and every required action is verified.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.CompleteAudit
     */ completeAudit: {
            name: "CompleteAudit",
            I: CompleteAuditRequest,
            O: CompleteAuditResponse,
            kind: MethodKind.Unary
        },
        /**
     * ResolveCorrectiveAction: the section owner marks their fix done (→ Resolved).
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ResolveCorrectiveAction
     */ resolveCorrectiveAction: {
            name: "ResolveCorrectiveAction",
            I: ResolveCorrectiveActionRequest,
            O: ResolveCorrectiveActionResponse,
            kind: MethodKind.Unary
        },
        /**
     * VerifyCorrectiveAction: the auditor accepts (→ Verified, item flips to Pass)
     * or rejects (→ back to Open, re-notifies the owner).
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.VerifyCorrectiveAction
     */ verifyCorrectiveAction: {
            name: "VerifyCorrectiveAction",
            I: VerifyCorrectiveActionRequest,
            O: VerifyCorrectiveActionResponse,
            kind: MethodKind.Unary
        },
        /**
     * WithdrawCorrectiveAction: the auditor cancels an action created in error
     * (→ Cancelled, a terminal state that lets the audit complete and does NOT
     * touch the linked checklist item). For a wrong/duplicate action, or one whose
     * item was re-recorded Pass/N/A.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.WithdrawCorrectiveAction
     */ withdrawCorrectiveAction: {
            name: "WithdrawCorrectiveAction",
            I: WithdrawCorrectiveActionRequest,
            O: WithdrawCorrectiveActionResponse,
            kind: MethodKind.Unary
        },
        /**
     * Per-program section → owner mapping.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListAuditSectionOwners
     */ listAuditSectionOwners: {
            name: "ListAuditSectionOwners",
            I: ListAuditSectionOwnersRequest,
            O: ListAuditSectionOwnersResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpsertAuditSectionOwner
     */ upsertAuditSectionOwner: {
            name: "UpsertAuditSectionOwner",
            I: UpsertAuditSectionOwnerRequest,
            O: UpsertAuditSectionOwnerResponse,
            kind: MethodKind.Unary
        },
        /**
     * === Deviations ===
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListDeviations
     */ listDeviations: {
            name: "ListDeviations",
            I: ListDeviationsRequest,
            O: ListDeviationsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpsertDeviation
     */ upsertDeviation: {
            name: "UpsertDeviation",
            I: UpsertDeviationRequest,
            O: UpsertDeviationResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeleteDeviation
     */ deleteDeviation: {
            name: "DeleteDeviation",
            I: DeleteDeviationRequest,
            O: DeleteDeviationResponse,
            kind: MethodKind.Unary
        },
        /**
     * === CPARS ===
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListCPARSScores
     */ listCPARSScores: {
            name: "ListCPARSScores",
            I: ListCPARSScoresRequest,
            O: ListCPARSScoresResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpsertCPARSScore
     */ upsertCPARSScore: {
            name: "UpsertCPARSScore",
            I: UpsertCPARSScoreRequest,
            O: UpsertCPARSScoreResponse,
            kind: MethodKind.Unary
        },
        /**
     * === QASP ===
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListQASPScores
     */ listQASPScores: {
            name: "ListQASPScores",
            I: ListQASPScoresRequest,
            O: ListQASPScoresResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpsertQASPScore
     */ upsertQASPScore: {
            name: "UpsertQASPScore",
            I: UpsertQASPScoreRequest,
            O: UpsertQASPScoreResponse,
            kind: MethodKind.Unary
        },
        /**
     * === Risks ===
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListRisks
     */ listRisks: {
            name: "ListRisks",
            I: ListRisksRequest,
            O: ListRisksResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpsertRisk
     */ upsertRisk: {
            name: "UpsertRisk",
            I: UpsertRiskRequest,
            O: UpsertRiskResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeleteRisk
     */ deleteRisk: {
            name: "DeleteRisk",
            I: DeleteRiskRequest,
            O: DeleteRiskResponse,
            kind: MethodKind.Unary
        },
        /**
     * Deliberate leadership escalation (NOT-S8 follow-up) — separate from
     * UpsertRisk so the frontend can gate it behind its own confirm dialog.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.EscalateRiskToLeadership
     */ escalateRiskToLeadership: {
            name: "EscalateRiskToLeadership",
            I: EscalateRiskToLeadershipRequest,
            O: EscalateRiskToLeadershipResponse,
            kind: MethodKind.Unary
        },
        /**
     * === Issues ===
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListIssues
     */ listIssues: {
            name: "ListIssues",
            I: ListIssuesRequest,
            O: ListIssuesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpsertIssue
     */ upsertIssue: {
            name: "UpsertIssue",
            I: UpsertIssueRequest,
            O: UpsertIssueResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeleteIssue
     */ deleteIssue: {
            name: "DeleteIssue",
            I: DeleteIssueRequest,
            O: DeleteIssueResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.ConvertRiskToIssue
     */ convertRiskToIssue: {
            name: "ConvertRiskToIssue",
            I: ConvertRiskToIssueRequest,
            O: ConvertRiskToIssueResponse,
            kind: MethodKind.Unary
        },
        /**
     * Append-only comment history on an issue: no update, no delete.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.AddIssueComment
     */ addIssueComment: {
            name: "AddIssueComment",
            I: AddIssueCommentRequest,
            O: AddIssueCommentResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListIssueComments
     */ listIssueComments: {
            name: "ListIssueComments",
            I: ListIssueCommentsRequest,
            O: ListIssueCommentsResponse,
            kind: MethodKind.Unary
        },
        /**
     * === Customer Touchpoints ===
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListCustomerTouchpoints
     */ listCustomerTouchpoints: {
            name: "ListCustomerTouchpoints",
            I: ListCustomerTouchpointsRequest,
            O: ListCustomerTouchpointsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.CreateCustomerTouchpoint
     */ createCustomerTouchpoint: {
            name: "CreateCustomerTouchpoint",
            I: CreateCustomerTouchpointRequest,
            O: CreateCustomerTouchpointResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpsertCustomerTouchpoint
     */ upsertCustomerTouchpoint: {
            name: "UpsertCustomerTouchpoint",
            I: UpsertCustomerTouchpointRequest,
            O: UpsertCustomerTouchpointResponse,
            kind: MethodKind.Unary
        },
        /**
     * Touchpoint file attachments, gated per-program (unlike a direct tesoro call,
     * which only checks same-tenant). Bytes still upload via tesoro's presigned
     * PUT; these only manage the touchpoint<->artifact link.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.AttachTouchpointFile
     */ attachTouchpointFile: {
            name: "AttachTouchpointFile",
            I: AttachTouchpointFileRequest,
            O: AttachTouchpointFileResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.DetachTouchpointFile
     */ detachTouchpointFile: {
            name: "DetachTouchpointFile",
            I: DetachTouchpointFileRequest,
            O: DetachTouchpointFileResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListTouchpointFiles
     */ listTouchpointFiles: {
            name: "ListTouchpointFiles",
            I: ListTouchpointFilesRequest,
            O: ListTouchpointFilesResponse,
            kind: MethodKind.Unary
        },
        /**
     * === Growth Opportunities ===
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListGrowthOpportunities
     */ listGrowthOpportunities: {
            name: "ListGrowthOpportunities",
            I: ListGrowthOpportunitiesRequest,
            O: ListGrowthOpportunitiesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpsertGrowthOpportunity
     */ upsertGrowthOpportunity: {
            name: "UpsertGrowthOpportunity",
            I: UpsertGrowthOpportunityRequest,
            O: UpsertGrowthOpportunityResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeleteGrowthOpportunity
     */ deleteGrowthOpportunity: {
            name: "DeleteGrowthOpportunity",
            I: DeleteGrowthOpportunityRequest,
            O: DeleteGrowthOpportunityResponse,
            kind: MethodKind.Unary
        },
        /**
     * === DSO (Days Sales Outstanding) ===
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListDSOEntries
     */ listDSOEntries: {
            name: "ListDSOEntries",
            I: ListDSOEntriesRequest,
            O: ListDSOEntriesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.CreateDSOEntry
     */ createDSOEntry: {
            name: "CreateDSOEntry",
            I: CreateDSOEntryRequest,
            O: CreateDSOEntryResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeleteDSOEntry
     */ deleteDSOEntry: {
            name: "DeleteDSOEntry",
            I: DeleteDSOEntryRequest,
            O: DeleteDSOEntryResponse,
            kind: MethodKind.Unary
        },
        /**
     * === EAC (Estimates at Completion) ===
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListEACEntries
     */ listEACEntries: {
            name: "ListEACEntries",
            I: ListEACEntriesRequest,
            O: ListEACEntriesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.CreateEACEntry
     */ createEACEntry: {
            name: "CreateEACEntry",
            I: CreateEACEntryRequest,
            O: CreateEACEntryResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpdateEACEntry
     */ updateEACEntry: {
            name: "UpdateEACEntry",
            I: UpdateEACEntryRequest,
            O: UpdateEACEntryResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeleteEACEntry
     */ deleteEACEntry: {
            name: "DeleteEACEntry",
            I: DeleteEACEntryRequest,
            O: DeleteEACEntryResponse,
            kind: MethodKind.Unary
        },
        /**
     * === Program Financial Months (SAD-166/SAD-176) ===
     * Monthly program-financial-health record (burn rate + AR balance), the
     * backend for the browser-facing Finance surface. Proxies pangaea's
     * ProgramFinancialMonth CRUD (datagateway/v1/delivery.proto) — DSO/EAC
     * above stay in place until a later migration retires them.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListProgramFinancialMonths
     */ listProgramFinancialMonths: {
            name: "ListProgramFinancialMonths",
            I: ListProgramFinancialMonthsRequest,
            O: ListProgramFinancialMonthsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpsertProgramFinancialMonth
     */ upsertProgramFinancialMonth: {
            name: "UpsertProgramFinancialMonth",
            I: UpsertProgramFinancialMonthRequest,
            O: UpsertProgramFinancialMonthResponse,
            kind: MethodKind.Unary
        },
        /**
     * Ceilings the whole order carries, with each document's value: the
     * Financial page's "Order ceilings".
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListProgramOrderCeilings
     */ listProgramOrderCeilings: {
            name: "ListProgramOrderCeilings",
            I: ListProgramOrderCeilingsRequest,
            O: ListProgramOrderCeilingsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Deliberately a separate RPC rather than a field on UpdateProgram: decision
     * D7 caveat C4 (major-push/august-roadmap/_decisions.md) records a real bug
     * where the full-replace program upsert zeroed money fields a modal didn't
     * echo back.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.SetProgramFundingAlertThreshold
     */ setProgramFundingAlertThreshold: {
            name: "SetProgramFundingAlertThreshold",
            I: SetProgramFundingAlertThresholdRequest,
            O: SetProgramFundingAlertThresholdResponse,
            kind: MethodKind.Unary
        },
        /**
     * === Subcontractor Reviews ===
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListSubcontractorReviews
     */ listSubcontractorReviews: {
            name: "ListSubcontractorReviews",
            I: ListSubcontractorReviewsRequest,
            O: ListSubcontractorReviewsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpsertSubcontractorReview
     */ upsertSubcontractorReview: {
            name: "UpsertSubcontractorReview",
            I: UpsertSubcontractorReviewRequest,
            O: UpsertSubcontractorReviewResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeleteSubcontractorReview
     */ deleteSubcontractorReview: {
            name: "DeleteSubcontractorReview",
            I: DeleteSubcontractorReviewRequest,
            O: DeleteSubcontractorReviewResponse,
            kind: MethodKind.Unary
        },
        /**
     * === Program Documents ===
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListProgramDocuments
     */ listProgramDocuments: {
            name: "ListProgramDocuments",
            I: ListProgramDocumentsRequest,
            O: ListProgramDocumentsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.CreateProgramDocument
     */ createProgramDocument: {
            name: "CreateProgramDocument",
            I: CreateProgramDocumentRequest,
            O: CreateProgramDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeleteProgramDocument
     */ deleteProgramDocument: {
            name: "DeleteProgramDocument",
            I: DeleteProgramDocumentRequest,
            O: DeleteProgramDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.SetProgramDocumentTags
     */ setProgramDocumentTags: {
            name: "SetProgramDocumentTags",
            I: SetProgramDocumentTagsRequest,
            O: SetProgramDocumentTagsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Reverie's processing outcome for a program document (service lane only).
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.SetProgramDocumentProcessing
     */ setProgramDocumentProcessing: {
            name: "SetProgramDocumentProcessing",
            I: SetProgramDocumentProcessingRequest,
            O: SetProgramDocumentProcessingResponse,
            kind: MethodKind.Unary
        },
        /**
     * === Audit Templates ===
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListAuditTemplates
     */ listAuditTemplates: {
            name: "ListAuditTemplates",
            I: ListAuditTemplatesRequest,
            O: ListAuditTemplatesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpsertAuditTemplate
     */ upsertAuditTemplate: {
            name: "UpsertAuditTemplate",
            I: UpsertAuditTemplateRequest,
            O: UpsertAuditTemplateResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.CreateAuditFromTemplate
     */ createAuditFromTemplate: {
            name: "CreateAuditFromTemplate",
            I: CreateAuditFromTemplateRequest,
            O: CreateAuditFromTemplateResponse,
            kind: MethodKind.Unary
        },
        /**
     * === IDIQ/BPA Aggregation ===
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListTaskOrders
     */ listTaskOrders: {
            name: "ListTaskOrders",
            I: ListTaskOrdersRequest,
            O: ListTaskOrdersResponse,
            kind: MethodKind.Unary
        },
        /**
     * === Dashboards ===
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.GetProgramFinancialSummary
     */ getProgramFinancialSummary: {
            name: "GetProgramFinancialSummary",
            I: GetProgramFinancialSummaryRequest,
            O: GetProgramFinancialSummaryResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.GetPortfolioDashboard
     */ getPortfolioDashboard: {
            name: "GetPortfolioDashboard",
            I: GetPortfolioDashboardRequest,
            O: GetPortfolioDashboardResponse,
            kind: MethodKind.Unary
        },
        /**
     * Phase 5a: cross-project delivery-truth KPI rollups (funding utilization,
     * on-time %, evidence completeness, open risk/issue counts) by portfolio and
     * sector. Proxies pangaea's ListPortfolioKPIs / ListSectorKPIs.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.GetDeliveryKPIRollups
     */ getDeliveryKPIRollups: {
            name: "GetDeliveryKPIRollups",
            I: GetDeliveryKPIRollupsRequest,
            O: GetDeliveryKPIRollupsResponse,
            kind: MethodKind.Unary
        },
        /**
     * RPT-01: windowed on-time delivery drill-down + report. Proxies pangaea's
     * GetOnTimeReport; numerator/denominator/pct in the response are recomputed
     * AFTER viewer projection, so a restricted viewer's percentage always
     * matches only the rows they can see.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.GetOnTimeReport
     */ getOnTimeReport: {
            name: "GetOnTimeReport",
            I: GetOnTimeReportRequest,
            O: GetOnTimeReportResponse,
            kind: MethodKind.Unary
        },
        /**
     * RPT-06: the weekly recap. Proxies pangaea's GetWeeklyRecap — same
     * windowed on-time report as above, scoped to one program, with each row
     * enriched by its linked program task's waiver state, notes, and days late.
     * Proto only for now; the Connect handler is a later task.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.GetWeeklyRecap
     */ getWeeklyRecap: {
            name: "GetWeeklyRecap",
            I: GetWeeklyRecapRequest,
            O: GetWeeklyRecapResponse,
            kind: MethodKind.Unary
        },
        /**
     * SAD-185 (RPT-07): tenant-wide open corrective-action counts — the one
     * number Home's delivery summary card needs that no existing read
     * provides. Proxies pangaea's CountOpenCorrectiveActions; rows are
     * projected per-program via projectByProgramID and total_open_count is
     * recomputed from the rows that survive that projection — never pangaea's
     * own total — mirroring GetOnTimeReport's projection-consistency contract.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.GetOpenCorrectiveActionCounts
     */ getOpenCorrectiveActionCounts: {
            name: "GetOpenCorrectiveActionCounts",
            I: GetOpenCorrectiveActionCountsRequest,
            O: GetOpenCorrectiveActionCountsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Phase 5c: cross-project delivery calendar (deadline aggregation) + the
     * signed-in user's notification inbox. Proxy pangaea's calendar/notification
     * reads; the inbox resolves the recipient from the gateway principal.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.GetDeliveryCalendar
     */ getDeliveryCalendar: {
            name: "GetDeliveryCalendar",
            I: GetDeliveryCalendarRequest,
            O: GetDeliveryCalendarResponse,
            kind: MethodKind.Unary
        },
        /**
     * SAD-105 layer 1: the deliverable-occurrence lookahead — deliverable
     * number, description, due date, and waiver status for individual
     * deliverable occurrences due today or within the following 14 calendar
     * days (15 dates total: today through day+14, inclusive). DELIBERATELY has
     * no due_after/due_before field: the request carries only company_id and
     * an optional program_id, so the window is computed entirely on the server
     * (see the handler) and a caller cannot widen, shift, or otherwise drift
     * what this window means.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.GetDeliverableLookahead
     */ getDeliverableLookahead: {
            name: "GetDeliverableLookahead",
            I: GetDeliverableLookaheadRequest,
            O: GetDeliverableLookaheadResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListMyNotifications
     */ listMyNotifications: {
            name: "ListMyNotifications",
            I: ListMyNotificationsRequest,
            O: ListMyNotificationsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.AcknowledgeNotification
     */ acknowledgeNotification: {
            name: "AcknowledgeNotification",
            I: AcknowledgeNotificationRequest,
            O: AcknowledgeNotificationResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.AcknowledgeAllNotifications
     */ acknowledgeAllNotifications: {
            name: "AcknowledgeAllNotifications",
            I: AcknowledgeAllNotificationsRequest,
            O: AcknowledgeAllNotificationsResponse,
            kind: MethodKind.Unary
        },
        /**
     * SAD-170 (D15/CON-11): the "assigned actions" feed. One RPC, two surfaces —
     * Program Home's "Mine" grouping and the Workroom signals panel both read
     * this. The recipient is resolved from the gateway principal, exactly like
     * ListMyNotifications above — never from the request, which is why the
     * request message below carries no user_id/contact_id/tenant_id field.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListMyAssignedActions
     */ listMyAssignedActions: {
            name: "ListMyAssignedActions",
            I: ListMyAssignedActionsRequest,
            O: ListMyAssignedActionsResponse,
            kind: MethodKind.Unary
        },
        /**
     * ListNotificationDeliveryStatus is the ACC-12 admin delivery-status read:
     * for a notification (or the tenant's most recent), its recipients and each
     * recipient's per-channel send attempts. ADMIN-ONLY — gated on the gateway
     * principal's admin/internal role, unlike the self-scoped inbox above. No
     * per-user preference surface; read-only.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListNotificationDeliveryStatus
     */ listNotificationDeliveryStatus: {
            name: "ListNotificationDeliveryStatus",
            I: ListNotificationDeliveryStatusRequest,
            O: ListNotificationDeliveryStatusResponse,
            kind: MethodKind.Unary
        },
        /**
     * SAD-954 notification preferences. The "My" pair is the signed-in
     * person's own, resolved from the gateway principal — the request names no
     * user, so nobody can read or change another person's. The company pair
     * is the tenant default every person inherits, readable and writable only
     * by an admin, internal, or a holder of area:company_settings.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.GetMyNotificationPreferences
     */ getMyNotificationPreferences: {
            name: "GetMyNotificationPreferences",
            I: GetMyNotificationPreferencesRequest,
            O: GetMyNotificationPreferencesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpdateMyNotificationPreferences
     */ updateMyNotificationPreferences: {
            name: "UpdateMyNotificationPreferences",
            I: UpdateMyNotificationPreferencesRequest,
            O: UpdateMyNotificationPreferencesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.GetCompanyNotificationDefaults
     */ getCompanyNotificationDefaults: {
            name: "GetCompanyNotificationDefaults",
            I: GetCompanyNotificationDefaultsRequest,
            O: GetCompanyNotificationDefaultsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpdateCompanyNotificationDefaults
     */ updateCompanyNotificationDefaults: {
            name: "UpdateCompanyNotificationDefaults",
            I: UpdateCompanyNotificationDefaultsRequest,
            O: UpdateCompanyNotificationDefaultsResponse,
            kind: MethodKind.Unary
        },
        /**
     * === Sync (called by reverie after contract processing) ===
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.SyncFromExtraction
     */ syncFromExtraction: {
            name: "SyncFromExtraction",
            I: SyncFromExtractionRequest,
            O: SyncFromExtractionResponse,
            kind: MethodKind.Unary
        },
        /**
     * The program glossary's write-back and cache lookup (SAD-857), on the same
     * principal-less service lane as SyncFromExtraction: reverie builds the
     * glossary from the program's documents, whoever uploaded them.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.SyncGlossarySection
     */ syncGlossarySection: {
            name: "SyncGlossarySection",
            I: SyncGlossarySectionRequest,
            O: SyncGlossarySectionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.FindGlossarySection
     */ findGlossarySection: {
            name: "FindGlossarySection",
            I: FindGlossarySectionRequest,
            O: FindGlossarySectionResponse,
            kind: MethodKind.Unary
        },
        /**
     * === Modification History ===
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListProgramModifications
     */ listProgramModifications: {
            name: "ListProgramModifications",
            I: ListProgramModificationsRequest,
            O: ListProgramModificationsResponse,
            kind: MethodKind.Unary
        },
        /**
     * === Phase 0a — Contract CLINs + Places of Performance (read-only) ===
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListContractCLINs
     */ listContractCLINs: {
            name: "ListContractCLINs",
            I: ListContractCLINsRequest,
            O: ListContractCLINsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListPlacesOfPerformance
     */ listPlacesOfPerformance: {
            name: "ListPlacesOfPerformance",
            I: ListPlacesOfPerformanceRequest,
            O: ListPlacesOfPerformanceResponse,
            kind: MethodKind.Unary
        },
        /**
     * === S11b — Region ownership (one employee owner per state) ===
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListRegionOwners
     */ listRegionOwners: {
            name: "ListRegionOwners",
            I: ListRegionOwnersRequest,
            O: ListRegionOwnersResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.SetRegionOwner
     */ setRegionOwner: {
            name: "SetRegionOwner",
            I: SetRegionOwnerRequest,
            O: SetRegionOwnerResponse,
            kind: MethodKind.Unary
        },
        /**
     * === SAD-186 — Project closeout checklists ===
     * Row-shaped proxies over pangaea's DeliveryGatewayService closeout RPCs —
     * domain invariants (copy-on-write template cloning, checklist snapshot,
     * Complete/CloseProgram gating) all live in pangaea's
     * CloseoutChecklistRepository (services/pangaea/pkg/repository/
     * delivery_closeout_repository.go).
     *
     * GetCloseoutChecklist returns NotFound when the program has no checklist
     * yet — the UI renders a "Start closeout" CTA, the same shape as
     * GetActivationGate in projectdata.proto. CompleteCloseoutChecklist returns
     * violations in the response rather than as an error, like
     * ActivateContractResponse.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.GetCloseoutChecklist
     */ getCloseoutChecklist: {
            name: "GetCloseoutChecklist",
            I: GetCloseoutChecklistRequest,
            O: GetCloseoutChecklistResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.StartCloseoutChecklist
     */ startCloseoutChecklist: {
            name: "StartCloseoutChecklist",
            I: StartCloseoutChecklistRequest,
            O: StartCloseoutChecklistResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.AnswerCloseoutChecklistItem
     */ answerCloseoutChecklistItem: {
            name: "AnswerCloseoutChecklistItem",
            I: AnswerCloseoutChecklistItemRequest,
            O: AnswerCloseoutChecklistItemResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpsertCloseoutOutstandingItem
     */ upsertCloseoutOutstandingItem: {
            name: "UpsertCloseoutOutstandingItem",
            I: UpsertCloseoutOutstandingItemRequest,
            O: UpsertCloseoutOutstandingItemResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeleteCloseoutOutstandingItem
     */ deleteCloseoutOutstandingItem: {
            name: "DeleteCloseoutOutstandingItem",
            I: DeleteCloseoutOutstandingItemRequest,
            O: DeleteCloseoutOutstandingItemResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.CompleteCloseoutChecklist
     */ completeCloseoutChecklist: {
            name: "CompleteCloseoutChecklist",
            I: CompleteCloseoutChecklistRequest,
            O: CompleteCloseoutChecklistResponse,
            kind: MethodKind.Unary
        },
        /**
     * ExportCloseoutChecklist (SAD-186 closeout export) renders the checklist —
     * items with their answers/comments, outstanding items with their resolved
     * state, and completion metadata — into an office document and lands it as
     * a program document artifact (Documents tab), so the completed closeout
     * survives as a durable record independent of the checklist rows. Refused
     * (FailedPrecondition) unless the checklist state is Completed; gated the
     * same per-area + per-program way as the rest of this RPC family (no
     * separate authority check — see closeout_export.go).
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ExportCloseoutChecklist
     */ exportCloseoutChecklist: {
            name: "ExportCloseoutChecklist",
            I: ExportCloseoutChecklistRequest,
            O: ExportCloseoutChecklistResponse,
            kind: MethodKind.Unary
        },
        /**
     * CloseProgram is a lifecycle transition (requireTransitionAuthority, verb
     * "close" — the SAME verb UpdateProgram's record_status_id flip and
     * DeleteProgram already require). Refused unless the program's checklist
     * state is Completed.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.CloseProgram
     */ closeProgram: {
            name: "CloseProgram",
            I: CloseProgramRequest,
            O: CloseProgramResponse,
            kind: MethodKind.Unary
        },
        /**
     * Period closeout, for CONTRACT periods (periods_of_performance) only:
     * period_id is always a contract period. Answers and outstanding items go
     * through AnswerCloseoutChecklistItem / *CloseoutOutstandingItem with
     * period_id set. ClosePeriod requires "close" transition authority, like
     * CloseProgram; it never hides the program.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListPeriodCloseouts
     */ listPeriodCloseouts: {
            name: "ListPeriodCloseouts",
            I: ListPeriodCloseoutsRequest,
            O: ListPeriodCloseoutsResponse,
            kind: MethodKind.Unary
        },
        /**
     * NotFound when the period has no checklist yet.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.GetPeriodCloseoutChecklist
     */ getPeriodCloseoutChecklist: {
            name: "GetPeriodCloseoutChecklist",
            I: GetPeriodCloseoutChecklistRequest,
            O: GetPeriodCloseoutChecklistResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.StartPeriodCloseoutChecklist
     */ startPeriodCloseoutChecklist: {
            name: "StartPeriodCloseoutChecklist",
            I: StartPeriodCloseoutChecklistRequest,
            O: StartPeriodCloseoutChecklistResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.ClosePeriod
     */ closePeriod: {
            name: "ClosePeriod",
            I: ClosePeriodRequest,
            O: ClosePeriodResponse,
            kind: MethodKind.Unary
        },
        /**
     * Checklist TEMPLATE curation is tenant-scoped shared-catalog work
     * (area:registries), not program-scoped — same posture as the LCAT
     * registry and contract vehicles.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListCloseoutTemplates
     */ listCloseoutTemplates: {
            name: "ListCloseoutTemplates",
            I: ListCloseoutTemplatesRequest,
            O: ListCloseoutTemplatesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpsertCloseoutTemplateItem
     */ upsertCloseoutTemplateItem: {
            name: "UpsertCloseoutTemplateItem",
            I: UpsertCloseoutTemplateItemRequest,
            O: UpsertCloseoutTemplateItemResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeleteCloseoutTemplateItem
     */ deleteCloseoutTemplateItem: {
            name: "DeleteCloseoutTemplateItem",
            I: DeleteCloseoutTemplateItemRequest,
            O: DeleteCloseoutTemplateItemResponse,
            kind: MethodKind.Unary
        },
        /**
     * SAD-171/SAD-174: let the program manager and quality delete a CPARS/QASP
     * score entered by mistake. Each request carries BOTH program_id and id —
     * unlike DeleteRisk and its sibling sub-entity deletes — so this write can
     * be gated per-program like every other quality write instead of falling
     * into the per-area-only deferred bucket (viewmode_write_registry.go file
     * header). The handler additionally requires "close" transition authority
     * (services/ryugu/pkg/connecthandlers/quality.go), not just area:quality
     * write access.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeleteCPARSScore
     */ deleteCPARSScore: {
            name: "DeleteCPARSScore",
            I: DeleteCPARSScoreRequest,
            O: DeleteCPARSScoreResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.DeleteQASPScore
     */ deleteQASPScore: {
            name: "DeleteQASPScore",
            I: DeleteQASPScoreRequest,
            O: DeleteQASPScoreResponse,
            kind: MethodKind.Unary
        },
        /**
     * === Execution scopes / Workstreams (Wave 0 contract freeze) ===
     * Names frozen from major-push/execution-scopes/07. Handlers return
     * Unimplemented until Lane E/F/I. Messages live in execution_scope.proto.
     *
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListExecutionScopes
     */ listExecutionScopes: {
            name: "ListExecutionScopes",
            I: ListExecutionScopesRequest,
            O: ListExecutionScopesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.GetExecutionScope
     */ getExecutionScope: {
            name: "GetExecutionScope",
            I: GetExecutionScopeRequest,
            O: GetExecutionScopeResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.GetExecutionScopeTimeline
     */ getExecutionScopeTimeline: {
            name: "GetExecutionScopeTimeline",
            I: GetExecutionScopeTimelineRequest,
            O: GetExecutionScopeTimelineResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.GetExecutionScopeCoverage
     */ getExecutionScopeCoverage: {
            name: "GetExecutionScopeCoverage",
            I: GetExecutionScopeCoverageRequest,
            O: GetExecutionScopeCoverageResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.CreateManualExecutionScope
     */ createManualExecutionScope: {
            name: "CreateManualExecutionScope",
            I: CreateManualExecutionScopeRequest,
            O: CreateManualExecutionScopeResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.UpdateManualExecutionScopeDraft
     */ updateManualExecutionScopeDraft: {
            name: "UpdateManualExecutionScopeDraft",
            I: UpdateManualExecutionScopeDraftRequest,
            O: UpdateManualExecutionScopeDraftResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.StageExecutionScopeArtifact
     */ stageExecutionScopeArtifact: {
            name: "StageExecutionScopeArtifact",
            I: StageExecutionScopeArtifactRequest,
            O: StageExecutionScopeArtifactResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.StageExecutionScopeCorrection
     */ stageExecutionScopeCorrection: {
            name: "StageExecutionScopeCorrection",
            I: StageExecutionScopeCorrectionRequest,
            O: StageExecutionScopeCorrectionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.GetExecutionScopeImportReview
     */ getExecutionScopeImportReview: {
            name: "GetExecutionScopeImportReview",
            I: GetExecutionScopeImportReviewRequest,
            O: GetExecutionScopeImportReviewResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.ResolveExecutionScopeProposal
     */ resolveExecutionScopeProposal: {
            name: "ResolveExecutionScopeProposal",
            I: ResolveExecutionScopeProposalRequest,
            O: ResolveExecutionScopeProposalResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.PreviewExecutionScopeApply
     */ previewExecutionScopeApply: {
            name: "PreviewExecutionScopeApply",
            I: PreviewExecutionScopeApplyRequest,
            O: PreviewExecutionScopeApplyResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.ApproveExecutionScopeChangeSet
     */ approveExecutionScopeChangeSet: {
            name: "ApproveExecutionScopeChangeSet",
            I: ApproveExecutionScopeChangeSetRequest,
            O: ApproveExecutionScopeChangeSetResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.ApplyExecutionScopeChangeSet
     */ applyExecutionScopeChangeSet: {
            name: "ApplyExecutionScopeChangeSet",
            I: ApplyExecutionScopeChangeSetRequest,
            O: ApplyExecutionScopeChangeSetResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListUnallocatedAuthority
     */ listUnallocatedAuthority: {
            name: "ListUnallocatedAuthority",
            I: ListUnallocatedAuthorityRequest,
            O: ListUnallocatedAuthorityResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.ListScopePressureItems
     */ listScopePressureItems: {
            name: "ListScopePressureItems",
            I: ListScopePressureItemsRequest,
            O: ListScopePressureItemsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.DeliveryService.BulkStageScopeDeviation
     */ bulkStageScopeDeviation: {
            name: "BulkStageScopeDeviation",
            I: BulkStageScopeDeviationRequest,
            O: BulkStageScopeDeviationResponse,
            kind: MethodKind.Unary
        }
    }
};
